/**
 * An array of strings representing the blacklisted link data keys.
 * These keys are excluded from the ad link data to prevent unwanted
 * properties from being included in the ad link creation or editing process.
 *
 * @constant
 * @type {string[]}
 * @example
 * // To check if a key is in the blacklist
 * const isBlacklisted = LINK_DATA_BLACKLIST.includes('some_key');
 */
export const AD_LINK_DATA_BLACKLIST: string[] = [
  '~branch_ad_format',
  '~campaign',
  '~campaign_type',
  '~channel',
  '~creation_source',
  '~feature',
  '~id',
  '~marketing',
  '~os_type',
  '~secondary_ad_format',
  '~tags',
  '~quick_link_template_id',
  '~link_template_id',
  '~link_type',
  '~stage',
  '~advertising_partner_name',
  '$android_deepview',
  '$android_url',
  '$custom_event_attribution_window_days',
  '$desktop_deepview',
  '$desktop_url',
  '$household_measurement',
  '$identity_id',
  '$ios_deepview',
  '$ios_url',
  '$link_title',
  '$marketing_title',
  '$og_description',
  '$og_image_url',
  '$og_title',
  '$one_time_use',
  '$3p',
  '+created_as_tune_link',
  '+match_guaranteed',
  '+url',
];
